import { render, staticRenderFns } from "./QuestionNav.vue?vue&type=template&id=0d4c7fc2&"
import script from "./QuestionNav.vue?vue&type=script&lang=js&"
export * from "./QuestionNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports